import axios from "axios";
import Vue from 'vue'
import store from './store/index.js';

// This will only be used if we separate the backend URL from the frontend
// const envURL = process.env.MIX_APP_URL
// const envInstance = createInstance(envURL ? envURL : "http://localhost:3000");

function createInstance(baseURL) {

    let jwtToken = '';
    if (window.data && window.data.loadView) {
        jwtToken = window.data.loadView;
    } else {
        jwtToken = localStorage.getItem('jwt');
    }

    const instance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${jwtToken}`
        }
    });

    instance.interceptors.request.use(
        (config) => {
            const token = store.getters.getUser.token;
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }

            // If client_id is set, add it to params
            if (instance._clientId) {
                config.params = config.params || {};
                config.params.client_id = instance._clientId;
                instance._clientId = null; // reset after use
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    /*
    we can use this field to track the client_id who updated the data (currently used in shipping options, packing rules)
    if you want to use this method, you can use it like this:
        this.$http.withClientId(clientId).post('/some-endpoint');
        then on the backend use the BindClientId middleware to bind the client_id to the request so you can access it in the controller
    */
    instance.withClientId = function (id) {
        this._clientId = id;
        return this;
    };

    return instance;
}

export default {
    install() {
        Vue.prototype.$http = createInstance('/')
    }
};